import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'

// 한 값을 클립보드로. 클립보드 API 가 없는 환경(평문 http 등)에서는 버튼이 없다 — 실패하는 버튼을 두지 않는다.
// `icon` 이면 아이콘 하나뿐이고, 복사한 뒤 잠깐 체크 표시로 바뀐다 — 값 칸의 오른쪽 귀퉁이에 둔다.

export function CopyButton({ text, label, icon = false }: { text: string; label: string; icon?: boolean }) {
  const [done, setDone] = useState(false)
  if (typeof navigator === 'undefined' || !navigator.clipboard) return null
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setDone(true)
      setTimeout(() => setDone(false), 1500)
    } catch {
      // 거부됐다면 사용자가 직접 긁어 복사한다. 알릴 것이 없다.
    }
  }
  const mark = done ? <Check className="size-3.5" /> : <Copy className="size-3.5" />
  if (icon) {
    return (
      <Button type="button" variant="ghost" size="icon-xs" onClick={copy} aria-label={label} title={label} className="max-sm:size-8">
        {mark}
      </Button>
    )
  }
  return (
    <Button type="button" variant="outline" size="sm" onClick={copy} aria-label={label}>
      {mark}
      {done ? '복사됨' : '복사'}
    </Button>
  )
}
